var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 5,
    viewBox: "0 0 19 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16667",
    "data-name": "Group 16667",
    transform: "translate(4751 612.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16660",
    "data-name": "Group 16660",
    transform: "translate(-4774 -1077.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_821",
    "data-name": "Ellipse 821",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(23 465)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_822",
    "data-name": "Ellipse 822",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(30 465)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_823",
    "data-name": "Ellipse 823",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(37 465)",
    fill: "#1ebcc2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.c268fb4f66a45b0c4fb5b29b55c7cf19.svg";
export { ForwardRef as ReactComponent };